// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)

import CalendarDragController from "./calendar_drag_controller"
application.register("calendar-drag", CalendarDragController)

import CopyController from "./copy_controller"
application.register("copy", CopyController)

import GreetingController from "./greeting_controller"
application.register("greeting", GreetingController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import IdeaPoolController from "./idea_pool_controller"
application.register("idea-pool", IdeaPoolController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import MiniAppController from "./mini_app_controller"
application.register("mini-app", MiniAppController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import PhotoUploadController from "./photo_upload_controller"
application.register("photo-upload", PhotoUploadController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import SelectFilterController from "./select_filter_controller"
application.register("select-filter", SelectFilterController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SubtextPickController from "./subtext_pick_controller"
application.register("subtext-pick", SubtextPickController)

import VideoAutoplayController from "./video_autoplay_controller"
application.register("video-autoplay", VideoAutoplayController)

import WizardController from "./wizard_controller"
application.register("wizard", WizardController)
